export const COLLAB_CURSOR_COLORS = [
  '#E57373', // red
  '#64B5F6', // blue
  '#81C784', // green
  '#FFB74D', // orange
  '#BA68C8', // purple
  '#4DB6AC', // teal
  '#F06292', // pink
  '#A1887F', // brown
  '#90A4AE', // blue-grey
  '#AED581', // light green
  '#FF8A65', // deep orange
  '#4FC3F7', // light blue
  '#9575CD', // deep purple
  '#DCE775', // lime
  '#4DD0E1', // cyan
  '#FFD54F', // amber
  '#7986CB', // indigo
  '#F48FB1', // pink light
  '#80CBC4', // teal light
  '#BCAAA4', // brown light
];

type CollabUserLike = {
  id?: string | number | null;
  email?: string | number | null;
  lastActive?: string | number | boolean | null;
};

export const COLLAB_AVATAR_COLOR_KEYS = COLLAB_CURSOR_COLORS.map(
  (_, idx) => `collab${idx}` as const,
);

export type CollabAvatarColorKey = (typeof COLLAB_AVATAR_COLOR_KEYS)[number];

const hashValue = (input: string): number => {
  let hash = 0;
  for (let idx = 0; idx < input.length; idx += 1) {
    hash = (hash << 5) - hash + input.charCodeAt(idx);
    hash |= 0;
  }
  return Math.abs(hash);
};

export const getUserCollabColor = (
  user?: CollabUserLike | null,
  fallbackSeed?: string | number,
): string => {
  const seed = user?.id ?? user?.email ?? fallbackSeed ?? 'anonymous';
  const index = hashValue(String(seed)) % COLLAB_CURSOR_COLORS.length;
  return COLLAB_CURSOR_COLORS[index];
};

export const isInactiveAvatarUser = (user?: CollabUserLike | null): boolean => {
  if (!user || !Object.prototype.hasOwnProperty.call(user, 'lastActive')) return false;
  return !user.lastActive;
};

export const getUserAvatarColor = (
  user?: CollabUserLike | null,
  fallbackSeed?: string | number,
): CollabAvatarColorKey | 'inactive' => {
  if (isInactiveAvatarUser(user)) return 'inactive';
  const seed = user?.id ?? user?.email ?? fallbackSeed ?? 'anonymous';
  const index = hashValue(String(seed)) % COLLAB_AVATAR_COLOR_KEYS.length;
  return COLLAB_AVATAR_COLOR_KEYS[index];
};
